module.exports = __webpack_public_path__ + "img/step6.a7a006c9.png";